// extracted by mini-css-extract-plugin
export default {"container":"styles_container__A33DW","zoomContainer":"styles_zoomContainer__zgFvz","zoomNumber":"styles_zoomNumber__8vpoV"};